import { messageErrorHandler } from "./errorHandler";

export const errorCatcher = reason => {
  if (reason?.response?.status === 400) {
    messageErrorHandler(reason?.response?.data?.errors);
  } else {
    console.log(reason)
  }
}